export enum SalePhase {
  WHITELIST = 0,
  PRESALE = 1,
  PUBLIC = 2,
}
